var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('BannerSmall'),_c('Feature'),_vm._l((_vm.formattedFaqs),function(value,key){return _c('Faq',{key:key,attrs:{"title":(key + " (" + (value.code) + ")"),"faq":value.faqs}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }